import React, { useState } from 'react';
import {
    FaProjectDiagram, FaMapMarkedAlt, FaChevronRight, FaPlus,
    FaCheck, FaDraftingCompass, FaHome, FaInfoCircle,
    FaCloudSun, FaLeaf, FaCalendarCheck, FaClock
} from 'react-icons/fa';
import styles from '../../pages/Account.module.css';

const TabProjects = ({ loadingProjects, projects, fetchProjects, handleViewProject, setActiveTab, userRole }) => {
    const isVisitor = userRole === 'user' || projects.length === 0;

    // Local state for simulation form (simplified for demo)
    const [simData, setSimData] = useState({
        type: 'Maison Individuelle',
        surface: '120',
        budget: '250',
        terrain: false
    });

    if (isVisitor) {
        return (
            <div className={styles.tabContent}>
                <h2 className={styles.contentTitle}>Conception de votre Projet</h2>

                <div className={styles.card}>
                    <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap' }}>
                        {/* Simulation Form Side */}
                        <div style={{ flex: '1 1 400px' }}>
                            <h3 style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <FaDraftingCompass color="var(--color-primary)" /> Simulateur de besoins
                            </h3>

                            <div className={styles.authForm} style={{ background: 'transparent', padding: 0, boxShadow: 'none' }}>
                                <div className={styles.formGroup}>
                                    <label>Type de construction</label>
                                    <select
                                        className={styles.modalSelect}
                                        value={simData.type}
                                        onChange={e => setSimData({ ...simData, type: e.target.value })}
                                    >
                                        <option>Maison Individuelle</option>
                                        <option>Extension / Agrandissement</option>
                                        <option>Garage / Atelier</option>
                                        <option>Architecture Contemporaine</option>
                                    </select>
                                </div>
                                <div className={styles.formRow}>
                                    <div className={styles.formGroup}>
                                        <label>Surface souhaitée (m²)</label>
                                        <input
                                            type="number"
                                            value={simData.surface}
                                            onChange={e => setSimData({ ...simData, surface: e.target.value })}
                                            placeholder="ex: 120"
                                        />
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Budget estimé (k€)</label>
                                        <input
                                            type="number"
                                            value={simData.budget}
                                            onChange={e => setSimData({ ...simData, budget: e.target.value })}
                                            placeholder="ex: 250"
                                        />
                                    </div>
                                </div>
                                <div className={styles.formGroup} style={{ flexDirection: 'row', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                                    <input
                                        type="checkbox"
                                        checked={simData.terrain}
                                        onChange={e => setSimData({ ...simData, terrain: e.target.checked })}
                                        style={{ width: '20px', height: '20px' }}
                                    />
                                    <label style={{ margin: 0 }}>J'ai déjà le terrain</label>
                                </div>

                                <button className={styles.submitButton} style={{ marginTop: '20px', width: '100%', justifyContent: 'center' }}>
                                    Enregistrer mes préférences
                                </button>
                            </div>
                        </div>

                        {/* Summary / Preview Side */}
                        <div style={{ flex: '1 1 300px', background: 'var(--color-bg-light, rgba(0,0,0,0.03))', padding: '25px', borderRadius: '15px', border: '1px solid var(--color-border, rgba(0,0,0,0.05))' }}>
                            <h4 style={{ color: 'var(--color-text-light)', fontSize: '0.9rem', marginBottom: '15px' }}>APERÇU DU PROJET</h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ width: '40px', height: '40px', background: 'var(--color-surface)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid var(--color-border)' }}>
                                        <FaHome color="var(--color-primary)" />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '0.75rem', color: 'var(--color-text-light)' }}>MODÈLE</div>
                                        <div style={{ fontWeight: '700' }}>{simData.type}</div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ width: '40px', height: '40px', background: 'var(--color-surface)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid var(--color-border)' }}>
                                        <FaMapMarkedAlt color="#3b82f6" />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '0.75rem', color: 'var(--color-text-light)' }}>TERRAIN</div>
                                        <div style={{ fontWeight: '700' }}>{simData.terrain ? "Validé" : "À rechercher"}</div>
                                    </div>
                                </div>

                                <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(164, 198, 57, 0.1)', borderRadius: '10px', border: '1px dashed var(--color-primary)' }}>
                                    <p style={{ fontSize: '0.85rem', color: 'var(--color-secondary)', margin: 0, fontWeight: '600' }}>
                                        <FaInfoCircle /> Besoin d'aide ?
                                    </p>
                                    <p style={{ fontSize: '0.8rem', color: 'var(--color-text-light)', marginTop: '5px' }}>
                                        Nos architectes peuvent vous aider à affiner ces critères gratuitement.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                    <div className={styles.card} style={{ padding: '20px', borderLeft: '4px solid #f59e0b' }}>
                        <h4 style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}><FaPlus /> Étape Suivante</h4>
                        <p style={{ fontSize: '0.9rem', color: 'var(--color-text-light)' }}>Prenez rendez-vous avec un conseiller pour transformer cette simulation en devis réel.</p>
                        <button className={styles.refreshBtn} style={{ marginTop: '10px' }} onClick={() => setActiveTab('booking')}>Prendre RDV</button>
                    </div>
                    <div className={styles.card} style={{ padding: '20px', borderLeft: '4px solid #10b981' }}>
                        <h4 style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}><FaCheck /> Recommandation</h4>
                        <p style={{ fontSize: '0.9rem', color: 'var(--color-text-light)' }}>Basé sur vos choix, nous vous recommandons la construction en ossature bois pour une meilleure isolation.</p>
                    </div>
                </div>
            </div>
        );
    }

    // CLIENT VIEW - Interactive Logbook
    const currentProject = projects[0] || {};
    const timelineSteps = [
        { status: 'completed', date: '10/02/2026', title: 'Fondations & Dalle', desc: 'Séchage en cours (10 jours)' },
        { status: 'active', date: '25/02/2026', title: 'Pose Ossature Bois', desc: 'Arrivée des murs pré-fabriqués' },
        { status: 'pending', date: '05/03/2026', title: 'Charpente & Toit', desc: 'Hors d\'eau / Hors d\'air' },
        { status: 'pending', date: '15/04/2026', title: 'Second Œuvre', desc: 'Isolation & Électricité' }
    ];

    return (
        <div className={styles.tabContent}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '25px', flexWrap: 'wrap', gap: '20px' }}>
                <div>
                    <h2 className={styles.contentTitle} style={{ margin: 0 }}>Journal de Bord : {currentProject.name}</h2>
                    <p style={{ color: '#64748b', fontSize: '0.9rem', marginTop: '5px' }}>
                        <FaMapMarkedAlt /> {currentProject.address} • Débuté le {new Date(currentProject.start_date).toLocaleDateString()}
                    </p>
                </div>
                <button className={styles.refreshBtn} onClick={fetchProjects} disabled={loadingProjects}>
                    Actualiser le flux
                </button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px' }}>
                {/* LEFT COLUMN: TIMELINE & PROGRESS */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                    <div className={styles.card}>
                        <h3 className={styles.cardTitle}><FaCalendarCheck /> Avancement Réel</h3>
                        <div className={styles.progressSection} style={{ marginBottom: '30px' }}>
                            <div className={styles.progressLabel}>
                                <span>Global</span>
                                <span>{currentProject.progress || 35}%</span>
                            </div>
                            <div className={styles.progressBar}>
                                <div className={styles.progressFill} style={{ width: `${currentProject.progress || 35}%` }}></div>
                            </div>
                        </div>

                        <div className={styles.timeline}>
                            {timelineSteps.map((s, i) => (
                                <div key={i} className={styles.timelineItem}>
                                    <div className={`${styles.timelineDot} ${s.status === 'completed' || s.status === 'active' ? styles.timelineDotActive : ''}`}></div>
                                    <div className={styles.timelineContent}>
                                        <div style={{ fontSize: '0.75rem', fontWeight: '800', color: s.status === 'active' ? 'var(--color-primary)' : '#94a3b8' }}>
                                            {s.date}
                                        </div>
                                        <h4 style={{ color: s.status === 'active' ? 'var(--color-secondary)' : '#1e293b' }}>
                                            {s.title}
                                            {s.status === 'active' && <span style={{ marginLeft: '10px', fontSize: '0.7rem', background: 'var(--color-primary)', color: 'white', padding: '2px 8px', borderRadius: '10px' }}>EN COURS</span>}
                                        </h4>
                                        <p>{s.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* RIGHT COLUMN: WIDGETS */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                    {/* WEATHER WIDGET */}
                    <div className={styles.weatherWidget}>
                        <div className={styles.weatherMain}>
                            <FaCloudSun size={40} />
                            <div>
                                <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>MÉTÉO DU CHANTIER</div>
                                <div className={styles.weatherTemp}>12°C</div>
                                <div style={{ fontSize: '0.85rem' }}>Beau temps • Conditions idéales</div>
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', fontSize: '0.9rem' }}>
                            <p style={{ margin: 0 }}>Humidité : 45%</p>
                            <p style={{ margin: 0 }}>Vent : 15km/h</p>
                        </div>
                    </div>

                    {/* CARBON COUNTER */}
                    <div className={styles.ecoCounter}>
                        <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaLeaf size={30} color="var(--color-primary)" />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: '700' }}>IMPACT CARBONE STOCKÉ</div>
                            <div className={styles.ecoValue}>-24.5 tCO2eq</div>
                            <p style={{ margin: '5px 0 0', fontSize: '0.75rem', color: '#64748b' }}>
                                Grâce à l'ossature bois de votre maison.
                            </p>
                        </div>
                    </div>

                    <div className={styles.card} style={{ background: 'var(--color-secondary)', color: 'white' }}>
                        <h4 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'white' }}><FaClock /> Prochaine Visite</h4>
                        <p style={{ fontSize: '1.4rem', fontWeight: '800', margin: '10px 0' }}>Jeudi 26 Février</p>
                        <p style={{ fontSize: '0.85rem', opacity: 0.8 }}>Réunion de chantier avec Marc (Conducteur de travaux) à 10h30.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TabProjects;
